/**
 * Mekke 通知フック
 * 共通フックを使用し、Mekke関連の通知タイプのみフィルタ
 */
import {
  useNotifications as useNotificationsCore,
  useMarkNotificationRead as useMarkNotificationReadCore,
  useMarkAllNotificationsRead as useMarkAllNotificationsReadCore,
  useDeleteNotification as useDeleteNotificationCore,
  notificationKeys,
} from "@tabipla/hooks/notifications";
import type { NotificationType } from "@tabipla/shared";
import { apiClient } from "../../infrastructure/api/client";

// Re-export query keys for direct access if needed
export { notificationKeys };

// Notification types relevant to Mekke (スポット記録アプリ)
const MEKKE_NOTIFICATION_TYPES: NotificationType[] = ["new_follower"];

// Mekke filters to follower-related notifications
export function useNotifications() {
  return useNotificationsCore({
    apiClient,
    filterTypes: MEKKE_NOTIFICATION_TYPES,
  });
}

export function useMarkNotificationRead() {
  return useMarkNotificationReadCore({ apiClient });
}

export function useMarkAllNotificationsRead() {
  return useMarkAllNotificationsReadCore({ apiClient });
}

export function useDeleteNotification() {
  return useDeleteNotificationCore({ apiClient });
}
